import React, { FC } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { DraggableListItem } from "./styled";
import { DraggableListProps } from "./types";

export const DraggableList: FC<DraggableListProps> = ({
  children,
  items,
  onDragStart,
  onDragEnd,
  id = "droppable",
  getId,
  className,
  direction,
  prefix,
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
      <Droppable direction={direction} droppableId={id}>
        {provided => (
          <DraggableListItem className={className} ref={provided.innerRef} {...provided.droppableProps}>
            {prefix}
            {items.map((item, index) => (
              <Draggable key={getId(item, index)} draggableId={getId(item, index)} index={index}>
                {(prop, snapshot) => children(item, prop, snapshot, index)}
              </Draggable>
            ))}
            {provided.placeholder}
          </DraggableListItem>
        )}
      </Droppable>
    </DragDropContext>
  );
};
